<template>
  <bean-source-page
    :type="type"
    :columns="columns"
    :form-columns="formColumns"
    :filter-columns="filterColumns"
    :actions="$route.params.id ? actions : []"
    :form="form"
    :title="$t('menu.placesListing')"
    resource="merchants"
    :actionButtons="actionButtons"
    :actionColumnProps="{ width: 220 }"
    :onFetchData="onFetchData"
    :batchActions="batchActions"
    :onFormSubmit="handleSubmit"
    :tableEvents="onTableEvents()"
  />
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import { filterColumnsExtend, columnsExtend, formColumnsExtend } from '../admin_grapes/merchants.js';
import _ from 'lodash';

@Component
export default class PlacesListing extends Vue {
  @Prop(String) type;
  actionButtons = ['show']

  // form 新建表单初始化数据（default数据）
  form = {}

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -RESTful api resource name
   */
  filterColumns() {
    const array = [
      'name_cont',
      {
        key: 'store_owner_id_eq',
        renderCell: {
          component: 'select',
          props: {
            clearable: true,
            xRemotePreload: async () => {
              const { data } = await this.$request.get('/store_owners/read_options', { per_page: 100 })
              return _.map(data, ({ id, first_name }) => ({ value: id, label: first_name }))
            },
            xRemoteSearch: async (keyword) => {
              const { data } = await this.$request.get('/store_owners/read_options', { keyword })
              return _.map(data, ({ id, first_name }) => ({ value: id, label: first_name }))
            }
          }
        }
      },
    ].filter(Boolean)

    return filterColumnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -RESTful api resource name
   */
  columns(h, { type }) {
    const array = [
      type === 'show' && 'id',
      {
        key: 'name',
        renderCell: (h, { props: { scope: { row } } }) => {
          if (row) {
            return <bean-link to={{ name: 'merchants.show', params: { id: row.id } }}>{row.name}</bean-link>
          }
        }
      },
      type === 'show' && {
        key: 'store_owner',
        renderCell: (h, { props: { value } }) => {
          if (value) {
            return <bean-link to={{ name: 'store_owners.show', params: { id: value.id } }}>{value.first_name}</bean-link>
          }
        }
      },
      'position',
      'phone',
      'whatsapp',
      type === 'show' && 'instagram',
      {
        prop: 'cashback_percent',
        label: this.$t('event.cashbackPercent'),
        renderCell: (h, { props: { scope: { row } } }) => {
          if (row.not_expired_event) {
            return <bean-link to={{ name: 'events.show', params: { id: row.not_expired_event.id } }}>{row.not_expired_event.cashback_percent}</bean-link>
          }
        }
      },
      'cover',
    ].filter(Boolean)

    return columnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource - RESTful api resoure name
   * @param {Object} params.data - current form data
   * @param {Function} params.change - invoke this method to sync form change({ field: 'new value' })
   */
  formColumns(h, { data, type }) {
    const array = [
      {
        key: 'name',
        renderCell: (h, { props: { value } }) => {
          return <span>{ value }</span>
        }
      },
      {
        key: 'store_owner',
        renderCell: (h, { props: { value } }) => {
          if (value) {
            return <bean-link to={{ name: 'store_owners.show', params: { id: value.id } }}>{value.first_name}</bean-link>
          } else {
            return <span>/</span>;
          }
        }
      },
      {
        key: 'position',
        renderCell: {
          hint: this.$t('hint.positionColumn')
        }
      }
    ].filter(Boolean)

    return formColumnsExtend(array, { data: data, type: type })
  }

  /**
   * @param {Object} scope -页面/表格 scope 数据
   * @param {Object} scope.row - 详情页/表格行 数据
   * @param {Object} sourcePageScope
   * @param {Function} sourcePageScope.remove - sourcePage删除方法
   * @param {Function} sourcePageScope.reload - sourcePage重新请求页面数据
   */
  actions({ row }, { reload }) {
    return [
      {
        component: 'routeButton',
        props: {
          label: this.$t('edit'),
          to: { name: 'places_listing.edit', params: { id: row.id } }
        }
      },
      {
        component: 'confirmButton',
        props: {
          label: this.$t('merchant.removeFromPlacesSection'),
          type: 'danger',
          can: 'merchants.update'
        },
        on: {
          confirm: async () => {
            await this.$request.put('/merchants/batch_update', { ids: [row.id], show_on_places_section: false });
            this.$message.success(this.$t('bean.updateSuccess'));
            reload();
          }
        }
      }
    ].filter(Boolean);
  }

  /**
   * @param {Object} scope -表格 scope 数据
   * @param {Object} scope.selection - 表格已选择行数据
   * @param {Object} sourcePageScope
   * @param {Function} sourcePageScope.remove - sourcePage删除方法
   * @param {Function} sourcePageScope.reload - sourcePage重新请求页面数据
   */
  batchActions({ selection }, { reload }) {
    const handleBatchAction = async () => {
      await this.$confirm(`${this.$t('bean.actionConfirm')} ${this.$t('merchant.removeFromPlacesSection')}`);
      await this.$request.put('/merchants/batch_update', { ids: _.map(selection, 'id'), show_on_places_section: false });
      this.$message.success(this.$t('bean.updateSuccess'));
      reload();
    }

    return [
      selection.length > 0 ? () => <el-button type="primary" onClick={handleBatchAction}>{this.$t('merchant.removeFromPlacesSection')} ({ selection.length })</el-button> :
        () => <el-button type="primary" disabled>{this.$t('merchant.removeFromPlacesSection')} ({ selection.length })</el-button>
    ];
  }

  async onFetchData({ type }) {
    if (type === 'index') {
      const { data, pagination } = await this.$request.get('/merchants', { params: { ...this.$route.query, show_on_places_section_eq: true } });
      return {
        data,
        pagination
      }
    }

    if (type === 'show' || type === 'edit') {
      const data = await this.$request.get(`/merchants/${this.$route.params.id}`);
      return { data };
    }
  }

  async handleSubmit({ data, type, resource, namespace }) {
    if (type === 'edit') {
      const { name, store_owner_id, whatsapp, position } = data;
      await this.$request.put(`/${namespace}${resource}/${data.id}`, { name, store_owner_id, whatsapp, position });
      this.$message.success(this.$t('bean.updateSuccess'));
      this.$router.push({ name: `places_listing.show`, params: { id: data.id } });
    }
  }

  onTableEvents() {
    const defaultEvents = {};
    if (this.actionButtons.includes('show')) {
      defaultEvents['row-click'] =  ({ id }) => {
        // 用户准备进行复制文字操作不要发生跳转
        if (window.getSelection) {
          const oSelection = window.getSelection();
          if (oSelection.toString) {
            const selection = oSelection.toString();
            if (selection) {
              return;
            }
          }
        }
        this.$router.push({ name: 'places_listing.show', params: { id } })
      };
    }
    return defaultEvents
  }
}

export const route = [
  {
    path: '/places_listing',
    name: 'places_listing.index',
    component: PlacesListing,
    props: {
      type: 'index',
    },
    meta: {
      can: 'merchants.read'
    }
  },
  {
    path: '/places_listing/:id',
    name: 'places_listing.show',
    component: PlacesListing,
    props: {
      type: 'show',
    },
    meta: {
      can: 'merchants.read'
    }
  },
  {
    path: '/places_listing/:id/edit',
    name: 'places_listing.edit',
    component: PlacesListing,
    props: {
      type: 'edit'
    },
    meta: {
      can: 'merchants.update'
    }
  }
]
</script>
